import { createSelector } from '@reduxjs/toolkit';

import { assertUnlessInProduction } from '@paragon/client-tools';

import { RootState } from '..';
import { getActiveAnalysisSet } from './getActiveAnalysisSetSelector';

// The active analysis set's component design guid should always match the active component design guid so no special
//   cases are needed for this guid-only selector.
export const getActiveComponentDesignGuid = (state: RootState) => state.selections.activeComponentDesignGuid;

export const getActiveComponentDesign = createSelector(
  getActiveComponentDesignGuid,
  (state: RootState) => state.componentDesigns,
  getActiveAnalysisSet,
  (activeComponentDesignGuid, componentDesigns, activeAnalysisSet) => {
    if (activeAnalysisSet) {
      if (activeAnalysisSet.componentDesign.guid !== activeComponentDesignGuid) {
        assertUnlessInProduction(
          "The active analysis set's component design GUID should always match the active component design GUID",
        );
      }

      return activeAnalysisSet.componentDesign;
    }

    if (activeComponentDesignGuid == null) return null;
    return componentDesigns.data[activeComponentDesignGuid] ?? null;
  },
);
